import { IState } from '@/state/IState';
import { setBuyerCommentThreads } from './actions';
import { Dispatch } from 'redux';
import { getCommentOverviewForBuyer } from '@/services/comments';

// export const loadBuyerCommentThreads = async (dispatch) => {
//     const residentialUnitId = useSelector((state: IState) => state.buyer.permissions!.residentialUnitId);
//     const data = await getBuyerCommentThreads(residentialUnitId);
//     dispatch(setBuyerCommentThreads(data));
// };

export function loadBuyerCommentThreads() {
    return async function(dispatch: Dispatch, getState: () => IState) {
        const residentialUnitId = getState().buyer.permissions!.residentialUnitId;
        const data = await getCommentOverviewForBuyer(residentialUnitId);
        dispatch(setBuyerCommentThreads(data));
    };
}